import { CORE_PLUGIN } from '@/core'
import type { ConsolePageOption, ConsolePageService, Plugin } from '@/plugins'
import { PLUGIN_CONSOLE_PAGE } from '@/plugins/builtin/BuiltinPluginSymbol'
import { defineStore } from 'pinia'
import {
  container,
  instanceCachingFactory,
  registry,
  singleton
} from 'tsyringe'

import CategoriesPage from './view/CategoriesPage.vue'
import SpuComment from './view/SpuComment.vue'

export const useProductStore = defineStore('productStore', {
  state: () => ({
    menusId: ''
  }),
  getters: {

  },
  actions: {

  },
})

export type ProductOption = {
  menusId: string
}

export type ProductAction = {
  //
}

export type ProductGetter = {
  //
}

export type ProductService = ProductAction & ProductGetter


/**
 * 插件的Option定义
 */
@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<ProductOption, ProductService>>(
      (c) => c.resolve(ShopProductPLugin)
    ),
  },
])
export class ShopProductPLugin implements Plugin<ProductOption, ProductService>{
  id: string | symbol = ''
  options: ProductOption
  service: ProductService
  constructor() {
    const instantiationStore = useProductStore()
    this.service = instantiationStore
    this.options = instantiationStore.$state
  }

  init(): void {
    const plugin = container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(PLUGIN_CONSOLE_PAGE)
    plugin.service.addChildRoute({
      path: 'products/spus',
      component: CategoriesPage,
    })
    plugin.service.addChildRoute({
      path: 'products/spus/comment/:id',
      component: SpuComment,
    })
  }

  initialized(): void {
    //
  }
}
